var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f8333c",
    d: "M29.373 3.279A3.76 3.76 0 0 0 26.721.627C24.381 0 15 0 15 0S5.619 0 3.279.627A3.76 3.76 0 0 0 .627 3.279C0 5.619 0 10.5 0 10.5s0 4.881.627 7.221a3.76 3.76 0 0 0 2.652 2.653C5.619 21 15 21 15 21s9.381 0 11.721-.627a3.76 3.76 0 0 0 2.652-2.652C30 15.382 30 10.5 30 10.5s0-4.881-.627-7.221M12 15V6l7.794 4.5z"
  })));
};
export default SvgYoutube;